/**
 * Stacking order for the QuerySettingsPanel drawer. The modal it can spawn
 * (via `RulesSection`) owns its own z-index; see
 * `shared/RulesSection/styles_vanilla.css.ts`.
 *
 * - `FullscreenTakeover` (the page behind the panel) sits at `1040`.
 * - `SlideoutDrawerV2` defaults to `1030/1040`, so we bump our drawer above
 *   the takeover.
 */
export const Z_INDEX = {
  drawer: 1050,
} as const;
